import { render, staticRenderFns } from "./diamondExchangeRecord.vue?vue&type=template&id=ded438e4&scoped=true"
import script from "./diamondExchangeRecord.vue?vue&type=script&lang=ts"
export * from "./diamondExchangeRecord.vue?vue&type=script&lang=ts"
import style0 from "./diamondExchangeRecord.vue?vue&type=style&index=0&id=ded438e4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded438e4",
  null
  
)

export default component.exports